import { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import DownloadSharpIcon from "@mui/icons-material/DownloadSharp";
import { useAnnouncementDetail } from "../../api/noticeApi";
import { getDepartmentName } from "../../utils/departmentUtils";
import { useIsMobile } from "../../hooks/useMediaQuery";

const AnnouncementDetail = () => {
  const { id } = useParams() as { id: string };
  const isMobile = useIsMobile();

  const { data, isLoading } = useAnnouncementDetail({ id });
  const {
    title,
    content,
    created_at: createdAt,
    creator_name: creatorName,
    department,
    signed_urls: signedUrls,
  } = useMemo(() => data?.announcement || {}, [data]);

  return (
    <div className="wideContent">
      {!isMobile && (
        <Link to="..">
          <button className="moveButton">뒤로가기</button>
        </Link>
      )}
      {isLoading ? (
        <p>로딩중...</p>
      ) : (
        <table id="announcementDetail">
          <tr>
            <td>제목</td>
            <td>
              [{getDepartmentName(department)}] {title}
            </td>
          </tr>
          <tr>
            <td>작성자</td>
            <td>{creatorName || "관리자"}</td>
          </tr>
          <tr>
            <td>작성 시간</td>
            <td>{moment(createdAt).format("YYYY-MM-DD LT")}</td>
          </tr>
          <tr className="announcementContent">
            <td>내용</td>
            <td style={{ whiteSpace: "pre-wrap" }}>
              <div style={{ minHeight: "150px", maxHeight: "350px" }}>
                {content}
              </div>
            </td>
          </tr>
          <tr>
            <td>첨부파일</td>
            <td>
              {signedUrls.map(
                ({ filename, url }: { filename: string; url: string }) => (
                  <a
                    href={url}
                    target="_self"
                    rel="noreferrer"
                    className="icon-button"
                  >
                    <DownloadSharpIcon /> {filename}
                  </a>
                )
              )}
            </td>
          </tr>
        </table>
      )}
      {isMobile && (
        <div className="buttonCenterWrapper">
          <Link to="..">
            <button className="moveButton">뒤로가기</button>
          </Link>
        </div>
      )}
    </div>
  );
};

export default AnnouncementDetail;
